import PageContent from "../PageContent/PageContent";
import { useEffect } from "react";

import InfoCover from "../PageContent/PageCovers/InfoCover";
import PropShow from "../PageContent/PropShow";
import BrancoAnim from "../PageContent/BrancoAnim";
import VideoAsk from "../PageContent/VideoAsk";
import Two from "../PageContent/Two";
import Fancy from "../PageContent/Fancy";
import PinkForm from "../PageContent/PinkForm";
import Footer from "../PageContent/Footer";
import CTAButton from "../PageContent/CTAButton";
import Map from "../PageContent/MapPart";
import Testimonial from "../PageContent/Testimonial";
import Marquee from "../PageContent/Marquee";
import QuestionBox from "../PageContent/QuestionBox";


const questionBoxData = {
    title: "ONZE VIDEOREPORTAGES MAKEN HET VERSCHIL",
    text: ["DROOMWONING GEVONDEN?", "BOEK DAN SNEL UW LIVE", "VIDEO RONDLEIDING."],
    button: "HOE WERKT DAT?"
}

function Lifestyle({ page, title, text }) {
    useEffect(() => {
        document.title = title ? title : page;
    }, [title, page]);

    return (
        <div className="content-ctnr">

            <InfoCover page={page} text={text} />
            <BrancoAnim page={page} text={text} />
            <VideoAsk />
            <Testimonial page={page} text={text} />
            <div>
                <video src="/Videos/Amàre Beach Hotel Ibiza.mp4" className="lifestyle-video" preload="false" autoPlay={true} muted={true} playsInline={true} loop={true}>
                </video>
            </div>
            {/* <Two page={page} text={text} /> */}
            <PropShow page={page} text={text} />
            <QuestionBox page={page} text={text} data={questionBoxData} />
            <Marquee />
            <PinkForm page={page} text={text} />
            <Map />

            <Footer page={page} text={text} />

            <CTAButton page={page} />


        </div>
    );
}

export default Lifestyle;